import React, { Component } from 'react';
import { connect } from 'react-redux';
import { MakeDepositSchema } from '../payment-methods/schemas';
import { BootstrapError, BootstrapField } from "../../helpers/Field";
import Payment from '../invoice/Payment';
import PayerSelect from '../invoice/PayerSelect';
import { getDepositReasonCodes, getPayerAccounts } from "../invoice/Selectors";
import { Formik } from "formik";
import * as appConstants from '../../constants/ApplicationConstants';
import {faChevronDown} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

class Deposits extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedReasonCode: appConstants.DEFAULT_DEPOSIT_REASON_CODE,
    };

    this.handleReasonCodeChange = this.handleReasonCodeChange.bind(this);
  }

  // TODO Delete
  // componentWillUnmount() {
  //   updateInvoiceSearchQuery(this.props.dispatch, false, '01', '', '', '', '', []);
  // }

  handleReasonCodeChange = (e) => {
    this.setState({ selectedReasonCode: e.target.value });
  };

  render() {
    const reasonCodes = this.props.depositReasonCodes;
    const { selectedReasonCode } = this.state;

    let initialValues = {
      payer_option: '',
      reason_code: selectedReasonCode,
      amount_to_process: '',
      reference_number: '',
      comment: '',
    };

    let schema = MakeDepositSchema;
    const isSoldToAccount = this.props.accountType === appConstants.SOLD_TO_COMPARE;

    return (
      <Formik initialValues={initialValues} validationSchema={schema} validateOnChange={true} validateOnBlur={true}
        render={(props) => (
          <form onSubmit={props.handleSubmit}>
            <div className="container">
              <div className="row">
                <div className="col-lg-2 col-md-4 col-sm-12 col-12">
                  <h2 className="invoicesHeading bottompadding">New Deposit</h2>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <div className="card">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-lg-2 col-md-4 col-sm-5 col-5 bottompadding">
                          <span className="float-right col-form-label col-form-label-sm text-secondary">Payer</span>
                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-12 col-12 bottompadding">
                              {isSoldToAccount ? <PayerSelect name={'payer_option'}/>: ''}
                          </div>
                          <div className="col-lg-1 col-md-2 col-sm-2 col-2 p-0 mt-1">
                          </div>
                        <div className="col-lg-2 col-md-4 col-sm-5 col-5 bottompadding">
                          <span className="float-right col-form-label col-form-label-sm text-secondary">Reason Code</span>
                        </div>
                        <div className="col-lg-4 col-md-8 col-sm-7 col-7 bottompadding customSelect">
                          <select
                            name="reason_code"
                            placeholder="Reason Codes"
                            className="form-control"
                            onChange={this.handleReasonCodeChange}>
                            {reasonCodes.map(code => {
                              return (
                                <option value={code.value} key={code.value}>
                                  {code.label}
                                </option>
                              )
                            })}
                          </select>
                          <FontAwesomeIcon icon={faChevronDown} className={"select-arrow"}/>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-2 col-md-4 col-sm-5 col-5 bottompadding">
                          <span className="float-right col-form-label col-form-label-sm text-secondary">Amount</span>
                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-5 col-5 bottompadding depositAmount">
                          <BootstrapField type="number" name="amount_to_process" onChange={props.handleChange} />
                          <BootstrapError name="amount_to_process" />
                        </div>
                        <div className="col-lg-1 col-md-2 col-sm-2 col-2 p-0 mt-1">
                          <span className="col-form-label col-form-label-sm text-secondary">USD</span>
                        </div>
                        <div className="col-lg-2 col-md-4 col-sm-5 col-5 bottompadding">
                          <span className="float-right col-form-label col-form-label-sm text-secondary">Document Number</span>
                        </div>
                        <div className="col-lg-4 col-md-8 col-sm-7 col-7 bottompadding">
                          <BootstrapField type="text" name="reference_number" />
                        </div>
                        <div className="col-lg-6 col-md-12 col-sm-12 col-12 bottompadding">
                        </div>
                        <div className="col-lg-2 col-md-4 col-sm-5 col-5 bottompadding">
                          <span className="float-right col-form-label col-form-label-sm text-secondary">Payment Note</span>
                        </div>
                        <div className="col-lg-4 col-md-8 col-sm-7 col-7 bottompadding">
                          <BootstrapField component="textarea" rows="3" name="comment" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <br />

              <div className="row">
                <div className="col-12">
                  {/* <Field component={Payment} {...props} name="depositPay" /> */}
                  {/* <Field component={Payment} {...props} name="deposityPay" isDepositOnly={true}/> */}
                  <Payment mode={"deposit"} form={props} />
                </div>
              </div>
              <br />
              <br />
              <br />
              <br />
              <br />
            </div>
          </form>
        )}
      />
    );
  }
}

export default connect((state, props) => {
  return {
    payerAccounts: getPayerAccounts(state, props),
    depositReasonCodes: getDepositReasonCodes(state, props),
    invoices: state.default.invoices,
    accountType: state.user_options.accountType,
    depositAmount: state.default.depositAmount,
  }
})(Deposits);
